// frontend/src/App.js
import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import {
    QueryClient,
    QueryClientProvider
} from '@tanstack/react-query';
import Cookies from 'js-cookie';
import React, { useLayoutEffect } from 'react';
import RootRoutes from './routes/RootRoutes';
import { NavigationProgress } from '@mantine/nprogress';
import { HelmetProvider } from 'react-helmet-async';

import '@mantine/nprogress/styles.css';
import '@mantine/dates/styles.css';

const theme = createTheme({
    /** Put your mantine theme override here */
});



// Create a client
const queryClient = new QueryClient()
const helmetContext = {};
const App = () => {

    useLayoutEffect(() => {

    })
    return (
        <HelmetProvider context={helmetContext}>

            <QueryClientProvider client={queryClient}>
                <MantineProvider theme={theme}>
                    <Notifications position='top-right' limit={5} />
                    <NavigationProgress color="pink" autoReset={true} size={5} />
                    <RootRoutes />
                </MantineProvider>
            </QueryClientProvider>
        </HelmetProvider>

    );
};

export default App;
